angular.module('picmonicng').component('homeFreeTrial', {
  templateUrl: '/templates/app/components/home-free-trial/home-free-trial.html',
  bindings: {},
  controller: [
    'UserService',
    'MarketOptionsConfig',
    function (UserService, MarketOptionsConfig) {
      var ctrl = this;
      ctrl.UserService = UserService;
      ctrl.isUserEducator = UserService.user.role === 'Professor';
      ctrl.isApprovedEducator = UserService.user.approved_educator === 1;
      ctrl.isFreeTrialExpired = UserService.user.free_trial_expiration < Date.now() / 1000;
      ctrl.isExpiredPremiumTrial = UserService.user.active_premium_types.length === 0;

      if (ctrl.isUserEducator) {
        ctrl.amountDays = ctrl.isApprovedEducator ? 7 : 5;
        ctrl.data = ctrl.isApprovedEducator
          ? UserService.user.premium_expiration
          : UserService.user.free_trial_expiration;
        ctrl.title = ctrl.isApprovedEducator ? 'Free Educator Trial Access' : 'Free Trial Access';
        ctrl.text =
          !ctrl.isApprovedEducator && !ctrl.isFreeTrialExpired
            ? 'Your free trial includes a limited number of Picmonics until we verify your educator status and unlock unlimited access for 7 days.'
            : (ctrl.isApprovedEducator && ctrl.isExpiredPremiumTrial) ||
              (!ctrl.isApprovedEducator && ctrl.isFreeTrialExpired)
            ? 'Your free educator trial has expired. You now have access to a limited number of Picmonics. Connect with us to learn more about a program partnership.'
            : 'You have unlimited access to the Picmonic library and Educator Dashboard for 7 days. Reach out to us to learn more about bringing Picmonic to your program.';
        ctrl.linkText = ctrl.isApprovedEducator ? 'Bring Picmonic to your program' : 'Explore Educator Partnership';
        ctrl.link = ctrl.isApprovedEducator
          ? 'https://content.truelearn.com/PicmonicEducatorResources'
          : 'https://www.picmonic.com/educators/';
      } else {
        ctrl.market = MarketOptionsConfig.getMarketById(UserService.user.lead);
        ctrl.amountDays = 5;
        ctrl.data = UserService.user.free_trial_expiration;
        ctrl.title = 'Free Trial Access';
        ctrl.text =
          'Your free trial includes ' +
          ctrl.market.free_trial_picmonics.length +
          ' popular Picmonics. Upgrade to unlock all videos, quizzes, offline playing, continuous audio, and more.';
      }
      var secondsLeft = Math.max(ctrl.data - Date.now() / 1000, 0);
      ctrl.expired = secondsLeft <= 0;
      ctrl.percentLeft = (secondsLeft / (86400 * ctrl.amountDays)) * 100;
      ctrl.daysRemaining = Math.ceil(secondsLeft / 86400);
      ctrl.progressStyle = { transform: 'rotate(' + (360 * (100 - ctrl.percentLeft)) / 100 + 'deg)' };

      ctrl.goToPicmonicEducatorResources = function () {
        if (ctrl.isUserEducator) {
          window.open(ctrl.link, '_blank');
        }
      };
    },
  ],
});
